<template>
  <div class="app-container">
    <div class="screeBox">
      <el-select
        filterable
        style="margin-right: 10px"
        v-model="screen.park_id"
        placeholder="请选择园区"
        :disabled="userInfo.park_id != 0"
        @change="parkChange"
      >
        <el-option label="全部" value=""></el-option>
        <el-option
          :label="item.name"
          :value="item.id"
          v-for="(item, index) in parkList"
          :key="index"
        ></el-option>
      </el-select>
      <el-select
        filterable
        :disabled="screen.park_id == ''"
        class="screenInput"
        v-model="screen.company_id"
        placeholder="请选择企业名称"
      >
        <el-option label="全部" value=""></el-option>
        <el-option
          :label="item1.name"
          :value="item1.id"
          v-for="(item1, index1) in screenCompanyList"
          :key="index1"
        ></el-option>
      </el-select>
      <el-input
        style="margin-right: 10px; width: 200px"
        v-model="screen.legal_search"
        placeholder="请输入业主姓名/手机号"
        maxlength="11"
      ></el-input>
      <el-input
        style="margin-right: 10px; width: 200px"
        v-model="screen.apply_search"
        placeholder="请输入申请人姓名/手机号"
        maxlength="11"
      ></el-input>
      <el-select
        filterable
        class="screenInput"
        v-model="screen.status"
        placeholder="请选择状态"
      >
        <el-option label="全部" value="-1"></el-option>
        <el-option
          v-if="activeName == 'apply'"
          label="发起申请"
          value="0"
        ></el-option>
        <el-option
          v-if="activeName == 'apply'"
          label="已通过"
          value="1"
        ></el-option>
        <el-option
          v-if="activeName == 'apply'"
          label="已拒绝"
          value="2"
        ></el-option>
        <el-option
          v-if="activeName == 'list'"
          label="已关闭"
          value="3"
        ></el-option>
        <el-option
          v-if="activeName == 'list'"
          label="装修中"
          value="4"
        ></el-option>
        <el-option
          v-if="activeName == 'list'"
          label="待验收"
          value="5"
        ></el-option>
        <el-option
          v-if="activeName == 'list'"
          label="已完成"
          value="6"
        ></el-option>
        <el-option
          v-if="activeName == 'list'"
          label="已评价"
          value="7"
        ></el-option>
      </el-select>
      <el-button type="primary" plain @click="reset()">重置</el-button>
      <el-button type="primary" @click="(screen.page = 1), fetchData()">搜索</el-button>
    </div>

    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="装修列表" name="list"></el-tab-pane>
      <el-tab-pane label="装修申请" name="apply"></el-tab-pane>
    </el-tabs>
    <el-button
      size="medium"
      type="primary"
      @click="addMenu()"
      style="float: right; margin-bottom: 10px"
      v-if="roles.includes('/renovation/apply_add') && activeName == 'apply'"
      >添加申请</el-button
    >
    <el-table
      max-height="700"  v-loading="listLoading" 
      :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
      :data="list"
      element-loading-text="Loading"
      fit
      highlight-current-row
      stripe
      class="table-box"
      tooltip-effect="dark"
      row-key="id"
      :tree-props="{ children: 'nodes', hasChildren: 'hasChildren' }"
    >
      <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">
          <!-- {{ scope.$index + 1 }} -->
          {{ (screen.page - 1) * screen.page_size + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="id" label="ID" width="50"> </el-table-column>
      <el-table-column label="所属园区" min-width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.park ? scope.row.park.name : "" }}</span>
        </template>
      </el-table-column>

      <el-table-column label="房源类型" min-width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.house_type }}</span>
        </template>
      </el-table-column>
      <el-table-column label="企业名称" min-width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.company ? scope.row.company.name : "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="房间号" min-width="150">
        <template slot-scope="scope">
          <span v-if="scope.row.houses.length">
            <div class="line2" v-for="(item, i) in scope.row.houses" :key="i">
              {{ item.house_name }}
            </div>
          </span>
        </template>
      </el-table-column>
      <el-table-column label="业主姓名" min-width="100">
        <template slot-scope="scope">
          {{ scope.row.legal_name }}
        </template>
      </el-table-column>
      <el-table-column label="业主手机号码" min-width="120">
        <template slot-scope="scope">
          {{ scope.row.legal_phone }}
        </template>
      </el-table-column>
      <el-table-column label="申请人姓名" min-width="100">
        <template slot-scope="scope">
          {{ scope.row.user_name }}
        </template>
      </el-table-column>
      <el-table-column label="申请人手机号码" min-width="120">
        <template slot-scope="scope">
          {{ scope.row.user_phone }}
        </template>
      </el-table-column>
      <el-table-column label="状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status == 0" type="info" disable-transitions
            >发起申请</el-tag
          >
          <el-tag
            v-if="scope.row.status == 1"
            type="success"
            disable-transitions
            >已通过</el-tag
          >
          <el-tag v-if="scope.row.status == 2" type="danger" disable-transitions
            >已拒绝</el-tag
          >
          <el-tag v-if="scope.row.status == 3" type="danger" disable-transitions
            >已关闭</el-tag
          >
          <el-tag
            v-if="scope.row.status == 4"
            type="warning"
            disable-transitions
            >装修中</el-tag
          >
          <el-tag v-if="scope.row.status == 5" type="" disable-transitions
            >待验收</el-tag
          >
          <el-tag
            v-if="scope.row.status == 6"
            type="success"
            disable-transitions
            >已完成</el-tag
          >
          <el-tag v-if="scope.row.status == 7" type="" disable-transitions
            >已评价</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column label="申请时间" min-width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.create_time }}</span>
        </template>
      </el-table-column>
      <el-table-column label="开始日期" min-width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.start_date }}</span>
        </template>
      </el-table-column>
      <el-table-column label="结束日期" min-width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.end_date }}</span>
        </template>
      </el-table-column>
      <el-table-column label="备注说明" min-width="150">
        <template slot-scope="scope">
          <div class="line2">{{ scope.row.describle }}</div>
        </template>
      </el-table-column>

      <el-table-column prop="created_at" label="操作" width="260" fixed="right">
        <template slot-scope="scope">
          <div v-if="activeName == 'list'">
            <div>
              <el-button
                size="mini"
                type="warning"
                @click="handleInfo(scope.row)"
                v-if="roles.includes('/renovation/apply_info')"
                >详情</el-button
              >
              <el-button
                size="mini"
                type="primary"
                @click="operate(scope.row, 'task')"
                >巡检任务</el-button
              >
              <el-button
                size="mini"
                type="primary"
                @click="getComment(scope.row.id)"
                v-if="
                  roles.includes('/renovation/apply_comment') &&
                  scope.row.status == 7
                "
                >查看评论</el-button
              >
            </div>
            <div style="margin-top: 10px">
              <el-button
                size="mini"
                type="info"
                @click="operate(scope.row, 'delay')"
                v-if="roles.includes('/renovation/delay')"
                >延期</el-button
              >
              <el-button
                size="mini"
                type="success"
                @click="operate(scope.row, 'check')"
                v-if="
                  roles.includes('/renovation/check') && scope.row.status == 5
                "
                >验收</el-button
              >

              <el-button
                size="mini"
                type="danger"
                @click="operate(scope.row, 'close')"
                v-if="
                  roles.includes('/renovation/close') && scope.row.status != 3
                "
                >关闭</el-button
              >
            </div>
          </div>
          <div v-if="activeName == 'apply'">
            <el-button
              size="mini"
              type="warning"
              @click="handleInfo(scope.row)"
              v-if="roles.includes('/renovation/apply_info')"
              >详情</el-button
            >

            <el-button
              size="mini"
              type="success"
              @click="handleEdit(scope.row)"
              v-if="roles.includes('/renovation/edit')"
              >编辑</el-button
            >
            <el-button
              size="mini"
              type="primary"
              @click="operate(scope.row, 'examine')"
              v-if="
                roles.includes('/renovation/apply_examine') &&
                scope.row.status == 0
              "
              >审核</el-button
            >
            <!-- <el-button
              style="margin: 10px 0 0 0"
              size="mini"
              type="danger"
              @click="operate(scope.row, 'close')"
              v-if="roles.includes('/renovation/close')"
              >关闭</el-button
            > -->
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="screen.page"
      :page-sizes="[15, 30, 50]"
      :page-size="screen.page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="margin-top: 10px"
    >
    </el-pagination>

    <!-- 详情信息 -->
    <el-drawer
      size="800px"
      :title="drawerTitle"
      :visible.sync="drawer"
      direction="rtl"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="150px"
        class="demo-ruleForm"
      >
        <h3 style="padding-left: 30px">基本信息</h3>
        <el-form-item label="园区" prop="park_id">
          <el-select
            filterable
            v-model="ruleForm.park_id"
            placeholder="请选择园区"
            disabled
          >
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in parkList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="房间号" prop="title">
          <div v-for="(item, index) in ruleForm.houses" :key="index">
            <el-input class="w4" disabled v-model="item.house_name"></el-input>
          </div>
        </el-form-item>

        <el-form-item label="企业名称" prop="sort">
          <el-input class="w4" v-model="ruleForm.company" disabled> </el-input>
        </el-form-item>
        <el-form-item label="业主姓名" prop="sort">
          <el-input
            v-model="ruleForm.legal_name"
            class="w4"
            placeholder="请输入排序"
            disabled
          >
          </el-input>
        </el-form-item>
        <el-form-item label="手机号码" prop="sort">
          <el-input
            maxlength="11"
            v-model="ruleForm.legal_phone"
            class="w4"
            placeholder="请输入排序"
            disabled
          >
          </el-input>
        </el-form-item>
        <h3 style="padding-left: 30px">装修信息</h3>

        <el-form-item label="装修时间" prop="sort">
          <el-date-picker
            v-model="ruleForm.manage_time"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            disabled
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item label="装修公司名称" prop="sort">
          <el-input class="w4" v-model="ruleForm.manage_company" disabled>
          </el-input>
        </el-form-item>
        <el-form-item label="施工负责人姓名" prop="sort">
          <el-input
            v-model="ruleForm.manage_name"
            class="w4"
            placeholder="请输入排序"
            disabled
          >
          </el-input>
        </el-form-item>
        <el-form-item label="装修负责人手机" prop="sort">
          <el-input
            maxlength="11"
            v-model="ruleForm.manage_phone"
            class="w4"
            placeholder="请输入排序"
            disabled
          >
          </el-input>
        </el-form-item>
        <el-form-item label="装修描述" prop="sort">
          <el-input
            type="textarea"
            v-model="ruleForm.describle"
            class="w4"
            placeholder="请输入排序"
            disabled
          >
          </el-input>
        </el-form-item>
        <el-form-item v-if="ruleForm.status == 2" label="拒绝原因" prop="sort">
          <el-input
            type="textarea"
            v-model="ruleForm.reason"
            class="w4"
            placeholder="请输入排序"
            disabled
          >
          </el-input>
        </el-form-item>
        <el-form-item v-if="ruleForm.status == 3" label="关闭原因" prop="sort">
          <el-input
            type="textarea"
            v-model="ruleForm.close_reason"
            class="w4"
            placeholder="请输入排序"
            disabled
          >
          </el-input>
        </el-form-item>
        <el-form-item v-if="ruleForm.status == 6" label="验收备注" prop="sort">
          <el-input
            type="textarea"
            v-model="ruleForm.success_reason"
            class="w4"
            placeholder="请输入排序"
            disabled
          >
          </el-input>
        </el-form-item>
        <h3 style="padding-left: 30px">档案信息</h3>
        <el-form-item label="档案编号" prop="file_no">
          <el-input
            v-model="ruleForm.file_no"
            class="w4"
            placeholder="请输入档案编号"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="装修开始日期" prop="start_date">
          <el-date-picker
            value-format="yyyy-MM-dd"
            v-model="ruleForm.start_date"
            type="date"
            placeholder="选择开始日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="装修结束日期" prop="end_date">
          <el-date-picker
            value-format="yyyy-MM-dd"
            v-model="ruleForm.end_date"
            type="date"
            placeholder="选择结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="附件" prop="files">
          <el-upload
            class="upload-demo"
            :action="ossUpload"
            name="file[]"
            :data="{ type: 'file' }"
            :headers="{ token: token }"
            accept=".doc,.xls,.xlsx,.pdf"
            :on-success="handleAvatarSuccess"
            :on-remove="handleRemove"
            :before-remove="beforeRemove"
            multiple
            :file-list="fileList"
          >
            <el-button  size="small" type="primary"
              >点击上传</el-button
            >
          </el-upload>
        </el-form-item>
        <el-form-item>
          <el-button
            v-if="czType == 'edit'"
            type="primary"
            @click="editForm('ruleForm')"
          >
            修改
          </el-button>
          <el-button
            v-if="czType == 'edit' || czType == 'see'"
            type="info"
            @click="drawer = false"
          >
            关闭
          </el-button>
        </el-form-item>
      </el-form>
    </el-drawer>
    <el-dialog
      :title="operateTitle"
      :visible.sync="dialogOperate"
      width="500px"
      :before-close="handleClose"
    >
      <el-form ref="operateFrom" label-width="100px" :model="operateFrom">
        <el-form-item
          v-if="operateType == 'delay'"
          label="延期日期"
          prop="delay_date"
          :rules="{
            required: true,
            message: '请选择延期日期',
            trigger: 'change',
          }"
        >
          <el-date-picker
            value-format="yyyy-MM-dd"
            v-model="operateFrom.delay_date"
            type="date"
            placeholder="选择延期日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item
          v-if="operateType == 'check'"
          label="验收备注"
          prop="success_reason"
          :rules="{
            required: true,
            message: '请输入验收备注',
            trigger: 'blur',
          }"
        >
          <el-input
            type="textarea"
            placeholder="请输入验收备注"
            v-model="operateFrom.success_reason"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          v-if="operateType == 'close'"
          label="关闭备注"
          prop="close_reason"
          :rules="{
            required: true,
            message: '请输入关闭备注',
            trigger: 'blur',
          }"
        >
          <el-input
            type="textarea"
            placeholder="请输入关闭备注"
            v-model="operateFrom.close_reason"
          >
          </el-input>
        </el-form-item>
        <div v-if="operateType == 'examine'">
          <el-form-item
            label="审核"
            prop="status"
            :rules="{
              required: true,
              message: '请选择审核状态',
              trigger: 'change',
            }"
          >
            <el-radio-group v-model="operateFrom.status">
              <el-radio :label="1">通过</el-radio>
              <el-radio :label="2">拒绝</el-radio>
            </el-radio-group>
          </el-form-item>
          <div v-if="operateFrom.status == 2">
            <el-form-item
              prop="reason"
              label="拒绝原因"
              :rules="{
                required: true,
                message: '请输入拒绝原因',
                trigger: 'blur',
              }"
            >
              <el-input type="textarea" v-model="operateFrom.reason"></el-input>
            </el-form-item>
          </div>
          <div v-if="operateFrom.status == 1">
            <el-form-item
              prop="patrol_type"
              label="巡检类型"
              :rules="{
                required: true,
                message: '请选择巡检类型',
                trigger: 'change',
              }"
            >
              <el-radio-group
                v-model="operateFrom.patrol_type"
                @change="patrolChange"
              >
                <el-radio :label="1">人</el-radio>
                <el-radio :label="2">角色</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              label="巡检人"
              prop="patrol_user_id"
              v-if="operateFrom.patrol_type == 1"
              :rules="{
                required: true,
                message: '请选择巡检人',
                trigger: 'change',
              }"
            >
              <el-select
                filterable
                v-model="operateFrom.patrol_user_id"
                placeholder="巡检人"
                collapse-tags
                @change="$forceUpdate()"
              >
                <el-option
                  :label="item.name"
                  :value="item.id"
                  v-for="item in userList"
                  :key="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="巡检角色"
              prop="patrol_role_id"
              v-if="operateFrom.patrol_type == 2"
              :rules="{
                required: true,
                message: '请选择巡检角色',
                trigger: 'change',
              }"
            >
              <el-select
                filterable
                v-model="operateFrom.patrol_role_id"
                placeholder="巡检角色"
                collapse-tags
                @change="$forceUpdate()"
              >
                <el-option
                  :label="item.title"
                  :value="item.id"
                  v-for="item in roleList"
                  :key="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              prop="is_scan"
              label="扫码巡检"
              :rules="{
                required: true,
                message: '请选择是否扫码巡检',
                trigger: 'change',
              }"
            >
              <el-radio-group v-model="operateFrom.is_scan">
                <el-radio :label="1">开启</el-radio>
                <el-radio :label="2">禁用</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
        </div>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogOperate = false">取 消</el-button>
        <el-button type="primary" @click="operateSubmit('operateFrom')"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <!-- 新增申请 -->
    <el-drawer
      size="800px"
      title="新增申请"
      :visible.sync="applyDrawer"
      direction="rtl"
    >
      <el-form
        :model="applyForm"
        :rules="applyRules"
        ref="applyForm"
        label-width="150px"
        class="demo-applyForm"
      >
        <el-form-item label="园区" prop="park_id">
          <el-select
            filterable
            v-model="applyForm.park_id"
            placeholder="请选择园区"
            @change="formParkChange"
          >
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in parkList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="房源类型">
          <el-radio-group
            v-model="applyForm.house_type"
            @input="houseTypeChange"
          >
            <el-radio :label="1">企业</el-radio>
            <el-radio :label="2">住宅</el-radio>
          </el-radio-group>
        </el-form-item>
        <div v-if="applyForm.house_type == 1">
          <el-form-item label="申请企业" prop="company_id">
            <el-select
              filterable
              v-model="applyForm.company_id"
              placeholder="请选择申请企业"
              @change="formCompanyChange"
            >
              <el-option
                :label="item1.name"
                :value="item1.id"
                v-for="(item1, index1) in formCompanyList"
                :key="index1"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="申请房屋" prop="space_house_id">
            <el-select
              :key="applyForm.house_type"
              filterable
              v-model="applyForm.space_house_id"
              placeholder="请选择申请房屋"
              multiple
              collapse-tags
            >
              <el-option
                :label="item1.name"
                :value="item1.space_house_id"
                v-for="(item1, index1) in formHouseList"
                :key="index1"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="申请人" prop="user_id">
            <el-select
              filterable
              v-model="applyForm.user_id"
              placeholder="请选择申请人"
            >
              <el-option
                :label="item1.name"
                :value="item1.id"
                v-for="(item1, index1) in formUserList"
                :key="index1"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div v-if="applyForm.house_type == 2">
          <el-form-item label="申请房屋" prop="space_house_id">
            <el-select
              filterable
              v-model="applyForm.space_house_id"
              placeholder="请选择申请房屋"
              @change="formHouseChange"
            >
              <el-option
                :label="item1.name"
                :value="item1.id"
                v-for="(item1, index1) in formHouseList"
                :key="index1"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="申请人" prop="user_id">
            <el-select
              filterable
              v-model="applyForm.user_id"
              placeholder="请选择申请人"
            >
              <el-option
                :label="item1.resident_name"
                :value="item1.user_id"
                v-for="(item1, index1) in formUserList"
                :key="index1"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>

        <el-form-item label="业主姓名" prop="legal_name">
          <el-input
            v-model="applyForm.legal_name"
            class="w4"
            placeholder="请输入业主姓名"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="手机号码" prop="legal_phone">
          <el-input
            maxlength="11"
            v-model="applyForm.legal_phone"
            class="w4"
            placeholder="请输入手机号码"
          >
          </el-input>
        </el-form-item>

        <el-form-item label="装修公司名称" prop="manage_company">
          <el-input
            class="w4"
            v-model="applyForm.manage_company"
            placeholder="请输入装修公司名称"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="装修负责人姓名" prop="manage_name">
          <el-input
            v-model="applyForm.manage_name"
            class="w4"
            placeholder="请输入装修负责人姓名"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="装修负责人手机" prop="manage_phone">
          <el-input
            maxlength="11"
            v-model="applyForm.manage_phone"
            class="w4"
            placeholder="请输入装修负责人手机"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="装修开始日期" prop="start_date">
          <el-date-picker
            value-format="yyyy-MM-dd"
            v-model="applyForm.start_date"
            type="date"
            placeholder="选择开始日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="装修结束日期" prop="end_date">
          <el-date-picker
            value-format="yyyy-MM-dd"
            v-model="applyForm.end_date"
            type="date"
            placeholder="选择结束日期"
            :picker-options="{
              disabledDate: (time) =>
                time.getTime() < new Date(new Date().setHours(0, 0, 0, 0)),
            }"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="装修描述" prop="describle">
          <el-input
            type="textarea"
            v-model="applyForm.describle"
            class="w4"
            placeholder="请输入装修描述"
          >
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="applySubmit('applyForm')">
            提交
          </el-button>
          <el-button type="info" @click="applyDrawer = false"> 关闭 </el-button>
        </el-form-item>
      </el-form>
    </el-drawer>
    <el-drawer title="查看评论" size="700px" :visible.sync="commentDrawer">
      <el-form label-width="120px">
        <el-form-item label="评论星级">
          <el-rate class="rate-form" v-model="comment.star" disabled> </el-rate>
        </el-form-item>
        <el-form-item label="评论内容">
          <el-input
            type="textarea"
            v-model="comment.content"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="commentDrawer = false">关闭</el-button>
        </el-form-item>
      </el-form>
    </el-drawer>

    <el-drawer
      size="800px"
      title="任务详情"
      :visible.sync="taskDrawer"
      direction="rtl"
      :before-close="handleClose"
    >
      <div class="codeBox">
        <img class="codeImg" :src="imageUrl + taskForm.qrcode" alt="" />
        <div class="btnBox">
          <el-button
            type="primary"
            @click="downloadByBlob(imageUrl + taskForm.qrcode)"
            >下载二维码</el-button
          >
          <el-button type="success" @click="register()" v-if="taskForm.status == 4">巡检登记</el-button>
        </div>
      </div>

      <el-form
        :model="taskForm"
        :rules="rules"
        ref="taskForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <h3 style="padding-left: 30px">装修巡检设置</h3>
        <el-form-item label="园区" prop="park_id">
          <el-select
            filterable
            v-model="taskForm.park_id"
            placeholder="请选择园区"
            disabled
            @change="formParkChange"
          >
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in parkList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否需要扫码" prop="is_scan">
          <el-radio-group v-model="taskForm.is_scan" disabled>
            <el-radio :label="1">开启</el-radio>
            <el-radio :label="2">不开启</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- <el-form-item label="任务状态" prop="status">
          <el-radio-group v-model="ruleForm.status" :disabled="czType == 'see'">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="2">禁用</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <el-form-item label="巡检人类型" prop="patrol_type">
          <el-radio-group v-model="taskForm.patrol_type" disabled>
            <el-radio :label="1">人</el-radio>
            <el-radio :label="2">角色</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="巡检人"
          prop="patrol_user_id"
          v-if="taskForm.patrol_type == 1"
        >
          <el-select
            disabled
            filterable
            v-model="taskForm.patrol_user_id"
            placeholder="巡检人"
            collapse-tags
            @change="$forceUpdate()"
          >
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="item in userList"
              :key="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="巡检角色"
          prop="patrol_role_id"
          v-if="taskForm.patrol_type == 2"
        >
          <el-select
            disabled
            filterable
            v-model="taskForm.patrol_role_id"
            placeholder="巡检角色"
            collapse-tags
            @change="$forceUpdate()"
          >
            <el-option
              :label="item.title"
              :value="item.id"
              v-for="item in roleList"
              :key="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="taskDrawer = false"> 关闭 </el-button>
        </el-form-item>
      </el-form>
    </el-drawer>

    <el-dialog
      title="添加巡检登记"
      :visible.sync="pollingDialog"
      width="650px"
      :before-close="handleClose"
    >
      <el-form
        style="max-height: 500px; overflow: auto"
        ref="pollingFrom"
        label-width="100px"
        :model="pollingFrom"
      >
        <el-form-item
          label="巡检时间"
          prop="patrol_time"
          :rules="{
            required: true,
            message: '请选择巡检时间',
            trigger: 'change',
          }"
        >
          <el-date-picker
            disabled
            value-format="yyyy-MM-dd HH:mm:ss"
            v-model="pollingFrom.patrol_time"
            type="datetime"
            placeholder="选择巡检时间"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item
          label="巡检人"
          prop="user_id"
          :rules="{
            required: true,
            message: '请选择巡检人',
            trigger: 'change',
          }"
        >
          <el-select
            filterable
            v-model="pollingFrom.user_id"
            placeholder="巡检人"
            collapse-tags
            @change="$forceUpdate()"
          >
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="item in renovationUserList"
              :key="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="审核"
          prop="status"
          :rules="{
            required: true,
            message: '请选择审核状态',
            trigger: 'change',
          }"
        >
          <el-radio-group v-model="pollingFrom.status">
            <el-radio :label="1">正常</el-radio>
            <el-radio :label="2">违规</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="remark" label="巡检说明">
          <el-input type="textarea" v-model="pollingFrom.remark"></el-input>
        </el-form-item>
        <el-form-item label="上传照片" prop="image">
          <el-upload
            class="avatar-uploaders1"
            :action="ossUpload"
            accept=".jpg,.png,.jpeg"
            name="file[]"
            :data="{ type: 'image' }"
            :headers="{ token: token }"
            list-type="picture-card"
            :show-file-list="true"
            :file-list="pollingFileList"
            :on-remove="pollingRemovePic"
            :on-success="pollingAvatarSuccess"
            :limit="6"
            :class="pollingFileList.length >= 6 ? 'hide' : ''"
          >
            <i class="el-icon-plus avatar-uploader-icon"></i> </el-upload
          ><!-- 已修改 -->
          <div class="pic-tips">最多添加6张图片</div>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="pollingDialog = false">取 消</el-button>
        <el-button type="primary" @click="pollingSubmit('pollingFrom')"
          >确 定</el-button
        >
      </span>
    </el-dialog>


  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Editor from "@/components/Editor";
import {
  openPark,
  openCompany,
  openAgoUser,
  openRole,
  get_company_house,
  get_park_houses,
  get_house_users,
  get_renovation_user_lists
} from "@/api/index";
import {
  applyList,
  setEdit,
  setDel,
  applyInfo,
  applyExamine,
  applyEdit,
  applyDelay,
  applyAdd,
  taskCheck,
  taskClose,
  apply_comment,
  // intention_user,
  taskInfo,
  taskPunchAdd
} from "@/api/renovation";
import { getToken } from "@/utils/auth";
export default {
  components: { Editor },
  computed: {
    ...mapGetters(["roles", "userInfo", "imageUrl", "imageOss"]),
  },
  data() {
    return {
      ossUpload: this.$store.state.ossUpload,
      token: getToken(),
      screen: {
        is_page: 1,
        page: 1,
        page_size: 15,
        company_id: "",
        park_id: "",
        legal_search: "",
        apply_search: "",
      },
      activeName: "list",
      parkList: [],
      screenCompanyList: [],
      total: 0,
      list: [],
      listLoading: true,
      czType: "",
      drawerTitle: "",
      fileList: [],
      filesList: [],
      ruleForm: {},
      drawer: false,
      rules: {
        // start_date: [
        //   { required: true, message: "请选择装修开始日期", trigger: "change" },
        // ],
        // file_no: [
        //   { required: true, message: "请输入档案编号", trigger: "blur" },
        // ],
        // end_date: [
        //   { required: true, message: "请选择装修结束日期", trigger: "change" },
        // ],
        // files: [{ required: true, message: "请选择附件", trigger: "change" }]
      },
      operateFrom: {},
      dialogOperate: false,
      operateTitle: "",
      operateType: "",
      roleList: [],
      userList: [],
      applyForm: {},
      applyDrawer: false,
      formUserList: [],
      formCompanyList: [],
      formHouseList: [],
      applyRules: {
        park_id: [{ required: true, message: "请选择园区" }],
        user_id: [{ required: true, message: "请选择申请人" }],
        space_house_id: [{ required: true, message: "请选择房屋" }],
        company_id: [{ required: true, message: "请选择申请企业" }],
        legal_name: [{ required: true, message: "请输入业主姓名" }],
        legal_phone: [
          { required: true, message: "请输入业主手机号", trigger: "blur" },
        ],
        manage_company: [{ required: true, message: "请输入装修公司名称" }],
        manage_name: [{ required: true, message: "请输入装修负责人姓名" }],
        manage_phone: [
          { required: true, message: "请输入装修负责人手机", trigger: "blur" },
        ],
        end_date: [
          { required: true, message: "请选择装修结束日期", trigger: "change" },
        ],
        start_date: [
          { required: true, message: "请选择装修开始日期", trigger: "change" },
        ],
      },
      comment: {},
      commentDrawer: false,
      taskDrawer: false,
      taskForm: {},
      renovationUserList:[],
      pollingDialog:false,
      pollingFrom:{},
      pollingFileList:[]
    };
  },
  created() {
    if (this.userInfo.park_id !== 0) {
      this.screen.park_id = this.userInfo.park_id;
    } else {
      this.screen.park_id = "";
    }
    this.fetchData();
    this.getPark();
  },
  methods: {
     // 操作提交
     pollingSubmit(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("确认提交？")
            .then(() => {
              taskPunchAdd(that.pollingFrom).then((res) => {
                if (res.code === 200) {
                  this.$message({
                    message: res.msg,
                    type: "success",
                  });
                  that.pollingDialog = false;
                }
              });
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
     // 图片上传
     pollingAvatarSuccess(res, file, fileList) {
      if (res.code === 200) {
        var list = [];
        list = fileList.map((item) => {
          return item.response.data.url;
        });
        this.pollingFrom.image = list.join(",");
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
        var list = [];
        fileList.map((item) => {
          if (item.response.code == 200) {
            list.push({
              name: +new Date(),
              url: imageOss + item.response.data.url,
              response: {
                data: {
                  url: item.response.data.url,
                },
              },
            });
          }
        });
        this.pollingFileList = list;
      }
      // this.ruleForm.icon = URL.createObjectURL(file.raw)
    },
    // 图片删除
    pollingRemovePic(file, fileList) {
      // if (file.response.data.url) {
      //   this.clearPics.push(file.response.data.url);
      // }
      var list = [];
      list = fileList.map((item) => {
        return item.response.data.url;
      });
      this.pollingFrom.image = list.join(",");
    },
     // 任务登记
    register() {
      this.pollingFrom = {
        user_id: "",
        patrol_task_id: this.taskForm.id,
        remark: "",
        image: "",
        status: 1,
        patrol_time: this.getNowTime(),
      };
      this.pollingDialog = true;
    },
    // 获取当前时间
    getNowTime() {
      let dateTime;
      let yy = new Date().getFullYear();
      let MM = new Date().getMonth() + 1;
      let dd = new Date().getDate();
      let hh = new Date().getHours();
      let mm =
        new Date().getMinutes() < 10
          ? "0" + new Date().getMinutes()
          : new Date().getMinutes();
      let ss =
        new Date().getSeconds() < 10
          ? "0" + new Date().getSeconds()
          : new Date().getSeconds();
      dateTime =
        yy +
        "-" +
        (MM > 9 ? MM : "0" + MM) +
        "-" +
        (dd > 9 ? dd : "0" + dd) +
        " " +
        hh +
        ":" +
        mm +
        ":" +
        ss;
      return dateTime;
    },
    // 获取装修巡检用户
    getRenovationUser(id, taskId) {
      get_renovation_user_lists({
        park_id: id,
        type: 1,
        is_page: 2,
        task_id: taskId,
      }).then((res) => {
        this.renovationUserList = res.data.lists;
      });
    },
    // 下载二维码图片
    downloadByBlob(imgsrc, name) {
      var image = new Image();
      // 解决跨域 Canvas 污染问题
      image.setAttribute("crossOrigin", "anonymous");
      image.onload = function () {
        var canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;

        var context = canvas.getContext("2d");
        context.drawImage(image, 0, 0, image.width, image.height);
        var url = canvas.toDataURL("image/png");
        var a = document.createElement("a");
        // 创建一个单击事件
        var event = new MouseEvent("click");
        a.download = this.qrCodeName;
        a.href = url;

        // 触发a的单击事件
        a.dispatchEvent(event);
      };
      image.src = imgsrc;
    },
    getComment(id) {
      apply_comment({ apply_id: id }).then((res) => {
        this.commentDrawer = true;
        res.data.star = +res.data.star;
        this.comment = res.data;
      });
    },
    applySubmit(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("确认提交？")
            .then(() => {
              let data = {
                park_id: that.applyForm.park_id,
                user_id: that.applyForm.user_id,
                company_id:
                  that.applyForm.house_type == 1
                    ? that.applyForm.company_id
                    : "",
                space_house_ids: this.applyForm.space_house_id.toString(),
                legal_name: that.applyForm.legal_name,
                legal_phone: that.applyForm.legal_phone,
                manage_company: that.applyForm.manage_company,
                manage_name: that.applyForm.manage_name,
                manage_phone: that.applyForm.manage_phone,
                start_date: that.applyForm.start_date,
                end_date: that.applyForm.end_date,
                describle: that.applyForm.describle,
              };
              applyAdd(data).then((res) => {
                if (res.code === 200) {
                  this.$message({
                    message: res.msg,
                    type: "success",
                  });
                  that.applyDrawer = false;
                  that.fetchData();
                }
              });
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });
          return false;
        }
      });
    },
    addMenu() {
      this.applyForm = {
        park_id: "",
        user_id: "",
        company_id: "",
        space_house_id: [],
        legal_name: "",
        legal_phone: "",
        manage_company: "",
        manage_name: "",
        manage_phone: "",
        start_date: "",
        end_date: "",
        describle: "",
        house_type: 1,
      };
      this.applyDrawer = true;
      // this.$refs.applyForm.resetFields()
    },
    // 房源类型切换
    houseTypeChange(e) {
      console.log(e);
      if (e == 1) {
        this.getCompany();
        this.applyForm.company_id = "";
        this.applyForm.space_house_id = [];
      } else if (e == 2) {
        this.getParkHouse();
        this.formHouseList = [];
        this.applyForm.space_house_id = "";
      }
      this.applyForm.user_id = "";
    },
    // 申请房屋选择
    formHouseChange(e) {
      get_house_users({ re_house_id: e }).then((res) => {
        this.formUserList = res.data.lists.data;
      });
    },

    formParkChange(e) {
      this.applyForm.user_id = "";
      this.applyForm.company_id = "";
      this.applyForm.space_house_id = [];
      this.formHouseList = [];
      if (this.applyForm.house_type == 1) {
        this.getCompany("form", e);
      } else {
        this.getParkHouse();
      }
    },
    formCompanyChange(e) {
      this.applyForm.space_house_id = [];
      this.applyForm.user_id = "";
      this.getAgoUser(this.applyForm.park_id, this.applyForm.company_id, 2);
      this.getHouse();
    },
    // 巡检类型修改
    patrolChange() {
      this.operateFrom.patrol_user_id = "";
      this.operateFrom.patrol_role_id = "";
    },
    // 装修申请编辑
    editForm(formName) {
      var that = this;
      // return
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("确认提交？")
            .then(() => {
              let data = {
                apply_id: that.ruleForm.apply_id,
                file_no: that.ruleForm.file_no,
                files: JSON.stringify(that.filesList),
                start_date: that.ruleForm.start_date,
                end_date: that.ruleForm.end_date,
              };
              // that.ruleForm.files = JSON.stringify(that.filesList)
              applyEdit(data).then((res) => {
                if (res.code === 200) {
                  that.drawer = false;
                  this.$message({
                    message: res.msg,
                    type: "success",
                  });
                  that.fetchData();
                }
              });
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    // 操作提交
    operateSubmit(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("确认提交？")
            .then(() => {
              if (that.operateType == "delay") {
                applyDelay(that.operateFrom).then((res) => {
                  if (res.code === 200) {
                    this.$message({
                      message: res.msg,
                      type: "success",
                    });
                    that.dialogOperate = false;
                    that.fetchData();
                  }
                });
              } else if (that.operateType == "check") {
                taskCheck(that.operateFrom).then((res) => {
                  if (res.code === 200) {
                    this.$message({
                      message: res.msg,
                      type: "success",
                    });
                    that.dialogOperate = false;
                    that.fetchData();
                  }
                });
              } else if (that.operateType == "close") {
                taskClose(that.operateFrom).then((res) => {
                  if (res.code === 200) {
                    this.$message({
                      message: res.msg,
                      type: "success",
                    });
                    that.dialogOperate = false;
                    that.fetchData();
                  }
                });
              } else if (that.operateType == "examine") {
                applyExamine(that.operateFrom).then((res) => {
                  if (res.code === 200) {
                    this.$message({
                      message: res.msg,
                      type: "success",
                    });
                    that.dialogOperate = false;
                    that.fetchData();
                  }
                });
              }
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    // 操作集合
    operate(e, type) {
      this.operateType = type;
      if (type == "delay") {
        // 延期
        this.operateFrom = {
          id: e.id,
          delay_date: "",
        };
        this.operateTitle = "装修延期";
        this.dialogOperate = true;
      } else if (type == "check") {
        // 验收
        this.operateFrom = {
          apply_id: e.id,
          success_reason: "",
        };
        this.operateTitle = "装修验收";
        this.dialogOperate = true;
      } else if (type == "close") {
        // 关闭
        this.operateFrom = {
          apply_id: e.id,
          close_reason: "",
        };
        this.operateTitle = "装修关闭";
        this.dialogOperate = true;
      } else if (type == "examine") {
        // 关闭
        this.operateFrom = {
          apply_id: e.id,
          park_id: e.park_id,
          status: 1,
          reason: "",
          patrol_type: 1,
          patrol_user_id: "",
          patrol_role_id: "",
          system_admin_id: this.userInfo.id,
          is_scan: 1,
        };
        this.getAgoUser(e.park_id, "", 1);
        this.getRole(e.park_id);
        this.operateTitle = "申请审批";
        this.dialogOperate = true;
      } else if (type == "task") {
        // 任务
        // this.$router.push({
        //   path: "/renovation/taskList",
        //   // query: { spaceId: id },
        // });
        this.getAgoUser(e.park_id, "", 1);
        this.getRole(e.park_id);
        this.getRenovationUser(e.park_id, e.task_id)
        this.getTaskInfo(e.task_id);
      }
    },
    getTaskInfo(id) {
      var that = this;
      taskInfo({ id: id }).then((res) => {
        // this.domains = res.data.company_role_data
        that.taskForm = {
          id: res.data.id,
          park_id: Number(res.data.park_id),
          is_scan: res.data.is_scan,
          status: res.data.status,
          patrol_type: res.data.patrol_type,
          patrol_user_id: res.data.patrol_user_id,
          patrol_role_id: res.data.patrol_role_id,
          qrcode: res.data.qrcode,
        };
        that.taskDrawer = true;
      });
    },

    // 设置文件大小
    setSize(size) {
      let kb = Number(size) / 1024;
      if (kb < 100) {
        return Math.ceil(kb) + "Kb";
      } else {
        if (kb > 1024) {
          let mb = kb / 1024;
          return mb.toFixed(2) + "MB";
        } else {
          return Math.ceil(kb) + "KB";
        }
      }
    },
    // 上传成功
    handleAvatarSuccess(res, file, fileList) {
      var that = this;
      if (res.code === 200) {
        this.fileList = fileList;
        this.filesList.push({
          size: that.setSize(file.size),
          file_name: file.name,
          file_path: file.response.data.url,
        });
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
        var list = [];
        fileList.map((item) => {
          if (item.response.code == 200) {
            list.push({
              name: +new Date(),
              url: imageOss + item.response.data.url,
              response: {
                data: {
                  url: item.response.data.url,
                },
              },
            });
          }
        });
        this.fileList = list;
      }
      // this.ruleForm.icon = URL.createObjectURL(file.raw)
    },
    // 上传删除
    handleRemove(file) {
      // this.fileList  = fileList
      const index = "";
      this.fileList.findIndex((item, index) => {
        if (item.uid === file.uid) {
          this.filesList.splice(index, 1);
          // index =  index
        }
      });
    },
    // 移除
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    // 查看
    handleEdit(val) {
      this.czType = "edit";
      this.drawerTitle = "编辑";
      this.getInfo(val.id);
      // this.drawer = true;
    },
    // 查看详情
    handleInfo(val) {
      this.czType = "see";
      this.drawerTitle = "查看";
      this.getInfo(val.id);
      // this.drawer = true;
    },
    // 获取详情信息
    getInfo(id) {
      var that = this;
      this.fileList = [];
      this.filesList = [];
      applyInfo({ id: id }).then((res) => {
        // this.domains = res.data.company_role_data
        that.ruleForm = {
          park_id: res.data.park_id,
          houses: res.data.houses,
          company: res.data.company ? res.data.company.name : "",
          legal_name: res.data.legal_name,
          legal_phone: res.data.legal_phone,
          manage_time: "",
          manage_company: res.data.manage_company,
          manage_name: res.data.manage_name,
          manage_phone: res.data.manage_phone,
          describle: res.data.describle,
          apply_id: res.data.id,
          file_no: res.data.file_no,
          files: [],
          start_date: res.data.start_date ? res.data.start_date : "",
          end_date: res.data.end_date ? res.data.end_date : "",
          status: res.data.status,
          reason: res.data.reason,
          close_reason: res.data.close_reason,
          success_reason: res.data.success_reason,
        };
        // if(res.data.start_date){
        //   this.$set(that.ruleForm, "start_date", res.data.start_date);
        // }
        // if(res.data.end_date){
        //   this.$set(that.ruleForm, "end_date", res.data.end_date);
        // }
        if (res.data.start_date && res.data.end_date) {
          let time = [];
          time[0] = res.data.start_date;
          time[1] = res.data.end_date;
          this.$set(that.ruleForm, "manage_time", time);
        }
        if (res.data.files) {
          let list = res.data.files;
          list.forEach((item) => {
            this.fileList.push({
              name: item.file_name,
              url: this.imageOss + item,
              response: {
                data: {
                  url: item,
                },
              },
            });
            this.filesList.push({
              size: item.size,
              file_name: item.file_name,
              file_path: item.file_path,
            });
          });
        }
      });
      this.drawer = true;
    },
    // 分页操作
    handleSizeChange(val) {
      this.screen.page_size = val;
      this.screen.page = 1;
      this.fetchData();
    },
    // 分页操作
    handleCurrentChange(val) {
      this.screen.page = val;
      this.fetchData();
    },
    // tab切换
    handleClick(tab, event) {
      this.screen = {
        park_id: "",
        legal_search: "",
        apply_search: "",
        company_id: "",
        page: 1,
        page_size: 15,
        is_page: 1,
        status: "-1",
      };
      this.fetchData();
    },
    // 重置筛选条件
    reset() {
      this.screen = {
        park_id: "",
        legal_search: "",
        apply_search: "",
        company_id: "",
        page: 1,
        page_size: 15,
        is_page: 1,
        status: "-1",
      };
      if (this.userInfo.park_id !== 0) {
        this.screen.park_id = this.userInfo.park_id;
      } else {
        this.screen.park_id = "";
      }
      this.fetchData();
    },

    // 筛选选择园区
    parkChange(e) {
      this.screen.company_id = "";
      this.getCompany("screen", e);
    },
    // 获取用户
    getAgoUser(parkId = "", companyId = "", type = 1) {
      openAgoUser({
        park_id: parkId,
        type: type,
        is_page: 2,
        company_id: companyId,
        is_youke:2
      }).then((res) => {
        if (type == 1) {
          this.userList = res.data.lists;
        } else {
          this.formUserList = res.data.lists;
        }
      });
    },
    // 获取角色
    getRole(id) {
      const data = {
        is_page: 2,
        is_tree: 1,
        park_id: id,
        type: 1,
        role_type: 2,
      };
      openRole(data).then((res) => {
        this.roleList = res.data.lists;
      });
    },
    // 获取园区
    getPark() {
      this.parkList = [];
      openPark({ is_page: 2, status: 1 }).then((res) => {
        this.parkList = res.data.lists;
      });
    },
    // 获取园区住宅列表
    getParkHouse() {
      get_park_houses({
        park_id: this.applyForm.park_id,
      }).then((res) => {
        this.formHouseList = res.data;
      });
    },
    // 获取企业房间列表
    getHouse() {
      get_company_house({
        park_id: this.applyForm.park_id,
        company_id: this.applyForm.company_id,
      }).then((res) => {
        this.formHouseList = res.data.lists.data;
      });
    },
    // 获取企业
    getCompany(type, id, index) {
      var data = {
        park_id: id,
        is_page: 2,
        index: index,
      };
      openCompany(data).then((response) => {
        if (type == "screen") {
          this.screenCompanyList = response.data.lists;
        } else if (type == "form") {
          this.formCompanyList = response.data.lists;
        }
      });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          this.$nextTick(() => {
            this.$refs.operateFrom.clearValidate();
          });
          done();
        })
        .catch(() => {});
    },
    // 获取table数据
    fetchData() {
      this.listLoading = true;
      this.screen.is_apply = this.activeName == "apply" ? 1 : 2;
      applyList(this.screen).then((response) => {
        this.list = response.data.data;
        this.total = response.data.total;
        this.listLoading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
// .el-button {
//   color: #000 !important;
// }
::v-deep .el-drawer__body {
  padding-right: 20px;
  overflow: auto;
}
.table-box {
  margin-top: 20px;
}
.video-box {
  width: 148px;
  height: 148px;
  position: relative;
  border-radius: 6px;
  overflow: hidden;
  video {
    width: 100%;
    height: 100%;
  }
  &:hover {
    .handles {
      opacity: 1;
    }
  }
  .handles {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 3;
    cursor: pointer;
    text-align: center;
    color: #fff;
    opacity: 0;
    font-size: 20px;
    background-color: rgba(0, 0, 0, 0.5);
    transition: opacity 0.3s;
    .el-icon-delete {
      font-size: 20px;
      color: #fff;
    }
  }
}
.avatar-uploaders {
  width: 80px;
  height: 80px;
  text-align: center;
  border: 1px solid #d9d9d9;
  line-height: 90px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}
.tableIcon {
  width: 50px;
  height: 50px;
}
.screenInput {
  width: 200px;
  margin: 0 10px 10px 0px;
}
.w4 {
  width: 40%;
}
::v-deep .el-table .el-table__body td .cell:empty::after,
.el-table .el-table__body td .cell > span:empty::after,
.el-table .el-table__body td .cell .approval:empty::after,
.el-table .el-table__body td .cell div:empty::after,
.el-table .el-table__body td .cell .line-limit-length:empty::after {
  content: "--";
}
.numInput {
  ::v-deep .el-input__inner {
    padding-right: 0 !important;
  }
}
.screeBox {
  // border-bottom: 1px solid #e4e7ed;
  padding-bottom: 16px;
}

// .demo-ruleForm {
//   ::v-deep .el-input.is-disabled .el-input__inner {
//     background: #fff;
//     color: #000;
//   }
//   ::v-deep .el-range-editor.is-disabled {
//     background: #fff;
//     color: #000;
//   }
//   ::v-deep .el-range-editor.is-disabled input {
//     color: #000;
//   }

//   ::v-deep .el-textarea.is-disabled .el-textarea__inner {
//     background: #fff;
//     color: #000;
//   }
// }
::v-deep .el-upload-list__item {
  transition: none !important;
}
::v-deep .rate-form {
  height: 100%;
  line-height: inherit;
  .el-rate__item {
    font-size: 14px !important;
  }
}

.codeBox {
  padding-left: 30px;
  display: flex;
  align-items: flex-end;
  .codeImg {
    width: 200px;
    height: 220px;
  }
  .btnBox {
    margin-left: 20px;
  }
}

//去除动画
::v-deep .el-list-enter-active,
::v-deep .el-list-leave-active {
  transition: all 0s;
}
</style>
